<div fxLayout="column" class="fee-comparison-display">
  <div class="stats-row">
    <div class="stats-summary-note">
      This summary calculates <span>{{calculationModeLabel}} fees, rates and savings</span> based off of
      <span>{{summaryBasisLabel}}</span> (see below for statement listing).
    </div>
    <div class="stats-row__blocks">
      <div class="stat-block">
        <div class="stat-block__header">
          <img src="./assets/images/svg/money-stack.png" alt="" class="stat-block__icon"
            style="width: 42px; height: 42px;">
          <span class="stat-block__title">Fees</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label">current</span>
          <span class="stat-block__value">{{getSummaryAverageCurrentTotalMonthlyFees() | currency}}</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label stat-block__label--bold">proposed</span>
          <span class="stat-block__value stat-block__value--bold">{{getSummaryAverageProposedTotalFees() |
            currency}}</span>
        </div>
      </div>

      <div class="stat-block">
        <div class="stat-block__header">
          <img src="./assets/images/svg/percent.png" alt="" class="stat-block__icon">
          <span class="stat-block__title">Rates</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label">current</span>
          <span class="stat-block__value">{{getCurrentEffectiveRateSummary() | percent: '1.2-2'}}</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label stat-block__label--bold">proposed</span>
          <span class="stat-block__value stat-block__value--bold">{{getProposedEffectiveRateSummary() | percent:
            '1.2-2'}}</span>
        </div>
      </div>

      <div class="stat-block">
        <div class="stat-block__header">
          <img src="./assets/images/svg/piggy-bank.png" alt="" class="stat-block__icon"
            style="width: 42px; height: 42px;">
          <span class="stat-block__title">Savings</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label stat-block__label--bold">monthly</span>
          <span class="stat-block__value stat-block__value--bold">{{getSavingsTotalMonthlyFees() | currency}}</span>
        </div>
        <hr class="stat-block__divider">
        <div class="stat-block__row">
          <span class="stat-block__label stat-block__label--bold">annual</span>
          <span class="stat-block__value stat-block__value--bold">{{getSavingsTotalMonthlyFees() * 12 |
            currency}}</span>
        </div>
      </div>
    </div>
    <div class="stats-summary-note border-top-monthly-statements">
      <p class="monthly-statements-title">Cost comparison summary includes the following monthly statements:</p>
      <div class="monthly-statements-grid"
        [style.grid-template-columns]="'repeat(' + Math.min(statementsToDisplay.length, 3) + ', 1fr)'">
        @for (statement of statementsToDisplay; track statement) {
        <span class="monthly-statement-item">{{statement}}</span>
        }
      </div>
    </div>
  </div>
  @if (proposal?.summaryNotes) {
  <div class="notes-container">
    <div class="notes-card">
      <span class="notes-card-title">Message from proposal preparer:</span>
      <div class="notes-card-content white-space-pre-wrap">{{proposal.summaryNotes}}</div>
      <span class="notes-card-signature">- Sam from Swipesum</span>
    </div>
  </div>
  }